/**
 * Accounts that see the dev tools launcher. This is an interim gate while the
 * EV specification is tested on the shared dev account; it will move to a
 * LaunchDarkly experiment for a set of dealers.
 *
 * The composer applies the same allowlist, so adding an email here alone does
 * not expose any data.
 */
export const DEV_ACCOUNT_EMAILS: ReadonlySet<string> = new Set(['dev@motorway.co.uk']);

/** Cookie the dev toggle sets; read on the server when fetching vehicle details. */
export const SHOW_EV_SPECIFICATION_COOKIE = 'mwShowEvSpecification';
